module.exports = __webpack_public_path__ + "static/img/recondo-2.47262cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/recondo-2.jpg
// module id = L99e
// module chunks = 1